import { IMenu } from '@frontend/useradmin/lib/interfaces/Menu.model';
import menuService from '@frontend/useradmin/lib/services/MenuService';
import sesionService from '@frontend/useradmin/lib/services/SesionService';
import { mdiBookOpen, mdiChartBar, mdiPresentationPlay, mdiViewDashboard } from '@mdi/js';
import Icon from '@mdi/react';
import { Breadcrumb, Button, Div, DropDown, FooterLayout, Header, Panel, Span } from '@reactjscomponentrepository/frontend-components/lib/components';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logotipo from '../images/logotipo_sim_interior.svg';

export const Home = () => {
  const navigate = useNavigate();
  const nombreUsuario = localStorage.getItem("usuario") == null ? 'Usuario no identificado' : localStorage.getItem("usuario")?.toUpperCase();
  const [menuSIM, setMenuSIM] = useState<[IMenu]>();

  const apm_breadcrumbs = [
    { path: '/home/apm', breadcrumb: 'APM' },
    { path: '/home/apm/conceptos/add', breadcrumb: 'Agregar' },
    { path: '/home/apm/conceptos/edit', breadcrumb: 'Editar' },
    { path: '/home/apm/catalogos/add', breadcrumb: 'Agregar' },
    { path: '/home/apm/catalogos/edit', breadcrumb: 'Editar' },
    { path: '/home/apm/catalogos/editCatalogoCodigo', breadcrumb: 'Editar' },
    { path: '/home/apm/plantillas/add', breadcrumb: 'Agregar' },
    { path: '/home/apm/plantillas/edit', breadcrumb: 'Editar' },
    { path: '/home/apm/contextos/edit', breadcrumb: 'Editar' },
  ];

  const cam_breadcrumbs: any = [
    { path: '/home/cam', breadcrumb: 'CEM' },
    { path: '/home/cam/plantilla', breadcrumb: 'Plantillas' },
    { path: '/home/cam/plantilla/documento', breadcrumb: 'Documentos de metadatos' },
    { path: '/home/cam/plantilla/documento/cuestionario', breadcrumb: 'Captura o edición' },
    { path: '/home/cam/estado', breadcrumb: 'Estados' },
  ];

  const cvm_breadcrumbs: any = [
    { path: '/home/cvm', breadcrumb: 'CVM' },
    { path: '/home/cvm/paquete', breadcrumb: 'Documentos' },
    { path: '/home/cvm/estadistica', breadcrumb: 'Estadísticas' },
  ];

  const admin_breadcrumbs: any = [
    { path: '/home/admin/usuarios/add', breadcrumb: 'Agregar' },
    { path: '/home/admin/usuarios/edit', breadcrumb: 'Editar' },
    { path: '/home/admin/servicios/add', breadcrumb: 'Agregar' },
    { path: '/home/admin/servicios/edit', breadcrumb: 'Editar' },
    { path: '/home/admin/sistemamodulo', breadcrumb: 'Sistemas-Módulos' },
    { path: '/home/admin/sistemamodulo/add', breadcrumb: 'Agregar' },
    { path: '/home/admin/sistemamodulo/edit', breadcrumb: 'Editar' },
    { path: '/home/admin/menu', breadcrumb: 'Menú' },
    { path: '/home/admin/menu/add', breadcrumb: 'Agregar' },
    { path: '/home/admin/menu/edit', breadcrumb: 'Editar' },
  ];

  const general_breadcrumbs = [
    { path: '/home', breadcrumb: 'Inicio' },
  ];

  const breadcrumbs = general_breadcrumbs.concat(apm_breadcrumbs.concat(cam_breadcrumbs.concat(cvm_breadcrumbs.concat(admin_breadcrumbs))));

  const handleCerrarSesion = useCallback(() => {
    sesionService.closeSesion()
      .then((response) => {
        if (response.status === 200) {
          toast.success(`Sesión cerrada`);
          localStorage.removeItem("usuario");
          localStorage.removeItem("token");
          navigate("/");
        }
      })
      .catch(rechazado => {
        if (rechazado.response.data.result.descripcion === 'El token proporcionado no corresponde a una sesión válida') {
          navigate('/')
        }

        if (rechazado.response.data.result.errores != null) {
          rechazado.response.data.result.errores.map((x: any) => (
            toast.error(x.errorMessage)
          ))
        }
        else {
          toast.error(rechazado.response.data.result.descripcion);
        }
      });
  }, [navigate])

  const getMenuSIM = () => {
    menuService.getSistemaMenu()
      .then((response) => {
        setMenuSIM(response.data.contenido);
      }
      )
      .catch(rechazado => {
        if (rechazado.response.status === 403 && rechazado.response.data.result.descripcion === 'La sesión ya ha sido cerrada') {
          toast.error(`La sesión ya ha sido cerrada`);
          localStorage.removeItem("usuario");
          localStorage.removeItem("token");
          navigate("/");
        }
        if (rechazado.response.data.result.errores != null) {
          rechazado.response.data.result.errores.map((x: any) => (
            toast.error(x.errorMessage)
          ))
        }
        else {
          toast.error(rechazado.response.data.result.descripcion);
        }
      });
  }

  useEffect(() => {
    axios.defaults.headers.common = { 'Authorization': 'Bearer ' + localStorage.getItem("token") };
    if (localStorage.getItem("usuario") == null) {
      handleCerrarSesion();
    }
    getMenuSIM();
  }, [handleCerrarSesion]);

  return (
    <>
      <Header systemLogo={logotipo} userName={nombreUsuario!} userOptions={[
        //<><Span>Perfil</Span></>,
        <><Span onClick={handleCerrarSesion}>Desconectarse</Span></>
      ]}>
        <Div className='flex w-100 align-center'>
          {
            menuSIM?.map(x => (
              (x.esPadre === true && x.idPadreMenuSim == null) ?
                x.url?.length > 0 ?
                  <Div className='mr-2 align-center flex pointer'><Icon path={mdiChartBar} title={x.nombre} size={.8} /> <Span onClick={() => navigate(x.url)}>{x.nombre}</Span></Div>
                  :
                  <DropDown position='left' className='mr-2 align-center flex p-0' selected={<><Icon className='mr-1' path={mdiBookOpen} title={x.nombre} size={.8} /> <Span>{x.nombre}</Span></>}>
                    {
                      menuSIM.filter(y => y.idPadreMenuSim === x.idMenuSim).map(y => (
                        <><Icon path={mdiViewDashboard} title={y.nombre} size={.8} /> <Span onClick={() => navigate(y.url)}>{y.nombre}</Span></>
                      ))
                    }
                  </DropDown>
                : null
            )
            )
          }
          <Div className='ml-auto'>
            <Button styleType='primary-outline' onClick={() => navigate("../learning")} className='align-center flex'><Icon path={mdiPresentationPlay} className="mr-2" size={.8} />Centro de ayuda</Button>
          </Div>
        </Div>
      </Header>
      <div className='block margin-lg p-3'>
        <Breadcrumb customBreadcrumbs={breadcrumbs} />
        <Panel>
          <Outlet />
        </Panel>
        <FooterLayout />
      </div>
    </>
  )
}
